module.exports = __webpack_public_path__ + "media/images/pic/lectors/justyna-szybinska-d553fb23ece7baf416dc51d8ca115431.jpeg";